import useEditor from '../../useEditor';
import ContentType from '../contenttype/ContentType'
import AddContentType from '../contenttype/AddContentType'
import SearchField from 'react-search-field';
import Select from 'react-select';
import { useState, useEffect } from 'react'

const ContentTypes = ({language, setBreadcrumbObject}) => {
    const { editor, setEditor } = useEditor();
    const [showDeleted, setShowDeleted] = useState(false)
    const [searchKeyword, setSearchKeyword] = useState('')
    const [filterSelect, setFilterSelect] = useState({value:0,label:language.value === 'DA' ? 'Ingen filter...' : 'No filter...'})
    const [contentModels, setContentModels] = useState([])
    const [contentTypes, setContentTypes] = useState([])
    const [contentTypesList, setContentTypesList] = useState(contentTypes)
    const [contentFilter, setContentFilter] = useState([])
    const [addContentTypeShow, setAddContentTypeShow] = useState(false)


    const handleAddContentTypeShow = async e => {
        e.preventDefault();
        setAddContentTypeShow(addContentTypeShow ? false : true)
    }

    const handleShowDeleted = async e => {
        e.preventDefault();
        setShowDeleted(showDeleted ? false : true)
    }

    useEffect(() => {
          
        const getData = async () => {
            const data = await fetchData()
            
            const filter = data.contentModels.map((contentModel) => {
                return {value: contentModel.id, label: contentModel.modelName};
            })
            setContentFilter([{value:0,label:language.value === 'DA' ? 'Ingen filter...' : 'No filter...'}, ...filter])
            setContentTypes(data.contentTypes)
            setContentTypesList(data.contentTypes)
            setContentModels(data.contentModels)
            global.config.Profile = data.editor.profile
            setBreadcrumbObject({type:'',name:language.value === 'DA' ? 'Indhold' : 'Content', link: '', linkText: ''})
          }
      
          getData()
      },[language, showDeleted])

    const fetchData = async () => {

        var graphql = JSON.stringify({
            query: `query ($deleted: Boolean, $id: Long){
                        contentTypes(deleted: $deleted) {
                            id
                            contentTypeId 
                            contentTypeName
                            contentModelId
                            isDraft
                            published
                            publishDate
                            scheduleDate
                            
                            contentModel{
                                modelName
                            }
                        }
                        contentModels{
                            id
                            modelName
                        }
                        editor(id: $id){
                            id

                            profile{
                                id
                                profileName
                                solutionId
                                isReadonly
                                hasAccessToSettings
                                hasAccessToModels
                                hasAccessToProfiles
                            }
                        }
                    }`,
            variables: {
                "deleted": showDeleted
                , "id": global.config.Editor.id
            }
          })
        const res = await fetch(global.config.GraphQL.url + global.config.Editor.publicToken ,{
            method:'POST',
            headers:{
                'Authorization':'Basic ' + global.config.Editor.authToken
                ,'Content-Type': 'application/json'
            },
            body: graphql
        })
        .then(response => response.text())
        .then(result => {return JSON.parse(result).data})
        .catch(error => console.log('error', error))
        const data = await res
        console.log('data', data)
        return data
    }
/*
    const fetchContentModels = async () => {
        const res = await fetch(global.config.Api.url + global.config.Editor.publicToken + '/ContentModel',{
            method:'GET',
            headers:{
                'Authorization':'Basic ' + global.config.Editor.authToken
            }
        })
        const data = await res.json()

        return data
    }
*/
    const filterContentModel = (selectedOption) => {
        setFilterSelect(selectedOption)
        filterContentTypes(searchKeyword, selectedOption.value)
    }
    
    const searchContentTypes = (keyword) => {
        setSearchKeyword(keyword)
        filterContentTypes(keyword,filterSelect.value)
    }

    const filterContentTypes = (keyword, contentModelId) => {
        setContentTypesList(
            contentTypes.filter((contentType) => 
                (contentType.contentTypeName.toLowerCase().includes(keyword.toLowerCase()))
                && (contentType.contentModelId === (contentModelId === 0 ? contentType.contentModelId : contentModelId))
            )
        )
    }

    return (
        <>
            <div id="cc_article_list_filter" className="cc_list_filter">
                <div className="filter-block">
                    <span>
                        {language.value === 'DA' ? 'Søg efter artikler' : 'Search for articles'}
                    </span>
                    
                    <Select className="filterSelect" classNamePrefix="filterSelect" options={contentFilter} onChange={filterContentModel} placeholder="Filter" />
                    <SearchField classNames="searchInput" onChange={searchContentTypes} placeholder={language.value === 'DA' ? 'Søger i artikelnavn' : 'Search in article name'} />
                </div>
                <div className="filter-block">
                    <span>&nbsp;</span>
                    <div className="btn-group">
                        <button onClick={handleShowDeleted} disabled={!showDeleted} className={`cc-btn ${showDeleted ? "" : "active"}`}>{language.value === 'DA' ? 'Aktive' : 'Active'}</button>
                        <button onClick={handleShowDeleted} disabled={showDeleted} className={`cc-btn ${showDeleted ? "active" : ""}`}>{language.value === 'DA' ? 'Slettede' : 'Deleted'}</button>
                    </div>
                </div>
                <div className="filter-block">
                    <span>&nbsp;</span>
                    <div className="btn-group">
                        {!showDeleted && <button onClick={handleAddContentTypeShow} className="cc-btn blue-gradient">{language.value === 'DA' ? 'Tilføj ny artikel' : 'Add new article'}</button> }
                    </div>
                </div>
            </div>
            <div id="cc_article_list" className="cc_item_list">
                <label className="list-header">
                    <span className="checkbox-container">&nbsp;</span>
                    <span className="name-container">{language.value === 'DA' ? 'Artikelnavn' : 'Articlename'}</span>
                    <span className="type-container">{language.value === 'DA' ? 'Artikeltype' : 'Articletype'}</span>
                    <span className="published-container">{language.value === 'DA' ? 'Publiceringdato' : 'Publisheddate'}</span>
                    <span className="edit-container">
                        &nbsp;
                    </span>
                </label>
                {contentTypesList.map((contentType) => (
                    <ContentType 
                        key={contentType.id}
                        language={language} 
                        contentType={contentType} 
                    />
                ))}

    
            </div>
            <AddContentType language={language} contentModels={contentModels} isVisible={addContentTypeShow} setIsVisible={setAddContentTypeShow}/> 
        </>
    )
}

export default ContentTypes
